import { render } from "./pIcon.vue?vue&type=template&id=b9312ec0"
import script from "./pIcon.vue?vue&type=script&lang=ts"
export * from "./pIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script